export default __webpack_public_path__ + "static/media/wishlist.ac7e9d9c.gif";